<template>
    <div class="article-detail">
        <div class="banner">
            <div class="title">最新文章</div>
        </div>

        <div class="article-detail-wrap container">
            <div class="breadcrumbs">
                <router-link :to="{ name: 'article'}">
                    <label class="clickable">最新文章</label>
                </router-link>
                <img src="@/assets/img/landingPage/arrow_right.svg"/>
                <label>文章詳情</label>
            </div>
            <div class="title">
                <div>{{article.title}}</div>
            </div>
            <div class="tags-list">
                <div class="tag" v-for="(tag, index) in article.tags" :key="index">{{tag}}</div>
            </div>
            <div class="cover" v-bind:style="{backgroundImage:'url(' + article.cover + ')'}"></div>
            <div class="content">
                <div class="paragraph" v-for="(paragraph, index) in article.content" :key="index">{{paragraph}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted () {
        this.$analytics.logEvent("文章內頁", {
            screen_name: "文章內頁"
        });
    },
    components: {

    },
    data () {
        return {
            article: {
                cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_2.jpeg',
                title: '房東們請自保，避免惡房客',
                tags: ['租金', '房東', '房租', '租約', '租屋', '欠款', '房客'],
                content: ['這年頭，房客找好房東難、房東找好房客更難。前陣子發生於屏東的美女租客3個月毀套房事件，讓全台房東心有餘悸，過去總有些房東偏好租給女生，殊不知知人知面不知心，美女房客看起來真無害，可怕的是關起門來生活習慣嚇死人，不但將房子弄的髒亂不堪且滿地垃圾、馬桶黃漬不刷、貓屎不清，可惡的是還積拖房租欠款，等到房東提告態度還極惡劣，搞得房東房子毀了，還得花時間與這名女房客周旋，真的也只能自認倒霉的承受一切。', '近年在居住正義大旗下，保障房客的法規越來越多，反而是房東缺乏發聲與保障管道，可惜的是除非房東本是神機妙算劉伯溫，不然很容易遇到那些破壞房屋、欠款房租、拒絕搬遷的惡房客，在這種無法真穿透人心地了解房客之時，我們列出幾項方法，讓房東們在簽租約前多一份安心，而不再只是靠運氣選房客。', '避免破壞房屋者：看房時的交談與行為觀察', '看房過程中要多與客人交談，觀察其行為舉止是否有不妥之處，房東可以要求房客提供良民證，若是急著入住的房客也要多留意，背後八成都有麻煩的故事。大多房東也擔心會租到有暴力傾向的房客，現在手機有開放下載警政服務app，裡面有治安項目可查捕逃犯的功能，只要輸入身分證字號與姓名，就能知道是否遭通緝，如此一來房東就能避免將房子租給不適當的人。', '避免積脫房租欠款者：簽租約前的身家背景調查', '在尚未見面時，房東可以從電話中進行簡單的身家調查，簡單詢問租屋需求以及工作單位等，初步了解房客的狀況，作為預約看房的前奏。後續也可以請房客提供工作證明或薪資證明，以避免收入不穩定的房客欠款房租。倘若真的遇到欠款房租者，房東們記得適當地進行催繳並留下其訊息通知，房東可以先從兩個月押金中扣抵房租欠款，若欠款租金達四個月，則要對房客寄送存證信函要求房客付租金，以維護自身權益。', '避免拒絕搬遷者：發送二次存證信函通知租約終止', '若房客持續不付租金，房東可以開始著手要求房客搬離租屋處，但房東切記千萬別自己擅自進入屋內，因為很有可能會觸犯強制罪、侵入住居罪，甚至遭反告竊盜及毀損罪，真正合法有效的方法是再次寄送存證信函，清楚表示租約終止日，若房客為於期限內搬離，房東可以到各縣市地方法院提出民事訴訟，要求房客返還房屋及繳清欠款，透過強制執行讓房客遷出。']
            }
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .article-detail {
        margin-bottom: 40px;
        .banner {
            display: none;
        }
        .container {
            width: 911px;
            margin-left: auto;
            margin-right: auto;
            box-sizing: border-box;
        }
        .article-detail-wrap {
            .breadcrumbs {
                margin-top: 40px;
                label.clickable {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #b1b0b0;
                    cursor: pointer;
                }
                label.clickable:hover {
                    color: #7d7979;
                }
                label{
                    font-size: 16px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #474342;
                    cursor: unset;
                }
                img {
                    margin-left: 12px;
                    margin-right: 12px;
                }
            }
            .title {
                margin-top: 34px;
                margin-bottom: 28px;
                div {
                    font-size: 26px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                }
            }
            .tags-list {
                margin-bottom: 20px;
                .tag {
                    display: inline-block;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #838282;
                    padding: 6px 14px;
                    border-radius: 5px;
                    background-color: #f1f3f6;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
            .cover {
                height: 400px;
                width: auto;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
            }
            .content {
                margin-top: 40px;
                .paragraph {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                    margin-bottom: 32px;
                }
            }
        }
    }
    @media screen and (max-width: 1100px){
        .article-detail {
            .banner {
                display: block;
                position: relative;
                margin-bottom: 14px;
                height: 198px;
                width: 100%;
                background-image: url('https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;

                .title {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 24px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #ffffff;
                }
            }
            .container {
                width: unset;
                padding: 0 20px;
            }
            .article-detail-wrap {
                .breadcrumbs {
                    display: none;
                }
                .cover {
                    height: 207px;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/officailPage/article/articleDetail_2.vue